import React, { Component } from 'react'
import CircularProgress from 'material-ui/CircularProgress'

export default class Loader extends Component {
	render(){
		return (
			<div style={{ position: "fixed", left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: "1000000000", top: "0" }}>
				<CircularProgress
					size={200}
					thickness={7} 
					style={{margin: "auto", left: "0", right: "0", bottom: "0", top: "0", position: "absolute"}}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Loader.js